import { Typography } from "antd";
import { Link } from "react-router-dom";
import { Plane } from "lucide-react";

const { Title, Text } = Typography;

export default function LegalPageLayout({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ background: "#fafafa", minHeight: "100vh" }}>
      <div
        style={{
          borderBottom: "1px solid #eee",
          background: "#fff",
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          to="/"
          style={{ display: "flex", alignItems: "center", gap: 8, color: "#111827", fontWeight: 700, fontSize: 18 }}
        >
          <Plane size={22} />
          Hairplane
        </Link>
        <Link to="/" style={{ fontSize: 13, color: "#6b7280" }}>
          ← Back to home
        </Link>
      </div>

      <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 96px" }}>
        <Title level={2} style={{ marginBottom: 4 }}>{title}</Title>
        <Text type="secondary">Last updated: {lastUpdated}</Text>

        <div className="legal-content" style={{ marginTop: 32, fontSize: 15, lineHeight: 1.7, color: "#1f2937" }}>
          {children}
        </div>
      </div>
    </div>
  );
}
